import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import * as AiIcons from "react-icons/ai";
import * as BsIcons from "react-icons/bs";
import * as RiIcons from "react-icons/ri";
import { NavLink } from "react-router-dom";
import Cookies from "universal-cookie";
import { sha256 } from "js-sha256";
import { useGlobalContext } from "../../context";
import swal from 'sweetalert';
import ApiSetting from "../../Settings/ApiSettings.json";
import axios from "axios";
const cookies = new Cookies();
const token = cookies.get("token");
const language = cookies.get("language") ? cookies.get("language") : "ar";
const MOFLogin = () => {
  const {
    // loading,
    setUserInfo,
  } = useGlobalContext();
  const [passwordText, setPasswordText] = useState("");
  const [IdText, setIdText] = useState("");
  const [passwordType, setPasswordType] = useState(false);
  const [loading,setLoading]=useState(false)
  const [erroMsg, setErrorMsg] = useState({
    empty: false,
    wrongInfo: false,
  });

  

    const login=async()=>{
      let data=null
      if (!IdText || !passwordText) {
        swal("تنبيه!", "اسم المستخدم وكلمة المرور مطلوب", "warning", {
          button: "حسنا",
        });
        return
      }
       try{
          
          setLoading(true)
          data=await axios({
            method:'post',
            url:ApiSetting.apiUrl+'/login',
            data:{
              username:IdText,
              password:passwordText
            },
            headers:{
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              "X-localization": language,
            }
          });

          if(data){
              if(data.data.status==200){
                setErrorMsg({
                  empty: false,
                  wrongInfo: false,
                });
                cookies.set("token", sha256(IdText + passwordText), { path: "/" });
                cookies.set("role_id", data?.data?.data?.role_id-1, { path: "/" });
                cookies.set("user_id", data?.data?.data?.id, { path: "/" });

                cookies.set("userName", IdText, { path: "/" });

                cookies.set("user-type", 4, { path: "/" });
                setUserInfo({ userName:  data?.data?.data?.name, role_id: data?.data?.data?.role_id-1 });
                window.location.href = "/mof-dashboard";

              }else{
                swal("تنبيه!", `${data.data.message}`, "warning", {
                  button: "حسنا",
                });
              }
          }else{
            setLoading(false)
          }
          setLoading(false)

       }
       catch(err){
        // swal("خطاء!", `${err.message}`, "error", {
        //   button: "حسنا",
        // });
        setLoading(false)
      }
    }
    // if (IdText === "branch manager" && passwordText === "1234") {
    //   setErrorMsg({
    //     empty: false,
    //     wrongInfo: false,
    //   });
    //   cookies.set("token", sha256(IdText + passwordText), { path: "/" });
    //   cookies.set("role_id", 1, { path: "/" });
    //   cookies.set("userName", IdText, { path: "/" });

    //   cookies.set("user-type", 4, { path: "/" });
    //   setUserInfo({ userName: "branch manager", role_id: 1 });
    //   window.location.href = "/mof-dashboard";
    // } else if (IdText === "checker" && passwordText === "1234") {
    //   setErrorMsg({
    //     empty: false,
    //     wrongInfo: false,
    //   });
    //   cookies.set("token", sha256(IdText + passwordText), { path: "/" });
    //   cookies.set("role_id", 2, { path: "/" });
    //   cookies.set("user-type", 4, { path: "/" });
    //   cookies.set("userName", IdText, { path: "/" });
    //   setUserInfo({ userName: "checker", role_id: 2 });

    //   window.location.href = "/mof-dashboard";
    // } else if (IdText === "estimator" && passwordText === "1234") {
    //   setErrorMsg({
    //     empty: false,
    //     wrongInfo: false,
    //   });
    //   cookies.set("token", sha256(IdText + passwordText), { path: "/" });
    //   cookies.set("role_id", 3, { path: "/" });
    //   cookies.set("user-type", 4, { path: "/" });
    //   cookies.set("userName", IdText, { path: "/" });
    //   setUserInfo({ userName: "estimator", role_id: 3 });
    //   window.location.href = "/mof-dashboard";
    // } else if (IdText === "tax payer" && passwordText === "1234") {
    //   setErrorMsg({
    //     empty: false,
    //     wrongInfo: false,
    //   });
    //   cookies.set("token", sha256(IdText + passwordText), { path: "/" });
    //   cookies.set("role_id", 4, { path: "/" });
    //   cookies.set("user-type", 4, { path: "/" });
    //   cookies.set("userName", IdText, { path: "/" });
    //   setUserInfo({ userName: "tax payer", role_id: 4 });
    //   window.location.href = "/mof-dashboard";
    // } else if (IdText === "officer" && passwordText === "1234") {
    //   setErrorMsg({
    //     empty: false,
    //     wrongInfo: false,
    //   });
    //   cookies.set("token", sha256(IdText + passwordText), { path: "/" });
    //   cookies.set("role_id", 5, { path: "/" });
    //   cookies.set("user-type", 4, { path: "/" });
    //   cookies.set("userName", IdText, { path: "/" });
    //   setUserInfo({ userName: "tax payer", role_id: 4 });
    //   window.location.href = "/mof-dashboard";
    // } else if (IdText === "admin" && passwordText === "1234") {
    //   setErrorMsg({
    //     empty: false,
    //     wrongInfo: false,
    //   });
    //   cookies.set("token", sha256(IdText + passwordText), { path: "/" });
    //   cookies.set("role_id", 0, { path: "/" });
    //   cookies.set("user-type", 4, { path: "/" });
    //   cookies.set("userName", IdText, { path: "/" });
    //   setUserInfo({ userName: "tax payer", role_id: 4 });
    //   window.location.href = "/mof-dashboard";
    // } else {
    //   if (IdText === "" && passwordText === "") {
    //     setErrorMsg({
    //       empty: true,
    //       wrongInfo: false,
    //     });
    //   } else {
    //     setErrorMsg({
    //       empty: false,
    //       wrongInfo: true,
    //     });
    //   }
    // }
  
  if (cookies.get("token") && cookies.get("user-type")) {
    console.log(cookies.get("user-type"));
    switch (cookies.get("user-type")) {
      case "1":
        window.location.href = "/doctor-dashboard";
        break;
      case "2":
        window.location.href = "/syndicate-dashboard";
        break;
      case "3":
        window.location.href = "/moh-dashboard";
        break;
      case "4":
        window.location.href = "/mof-dashboard";
        break;
      default:
        break;
    }
  }
  return (
    <div className="Doctor-div">
      <div className="Doctor-card">
        <div
          className="Doctor-rightCard"
          style={{ backgroundColor: "#9A593C" }}
        >
          <div
            style={{
              height: "85%",
              display: "flex",
              flexDirection: "column",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <RiIcons.RiBankFill size={180} style={{ marginBottom: 30 }} />
            <h1>مرحباً بكً</h1>
            <h6>
              يرجى تسجيل الدخول <br></br>وفق المعلومات المطلوبة
            </h6>
          </div>
          <h6>لطلب المساعدة</h6>
          <div
            style={{
              display: "flex",
              marginTop: -10,
              flexDirection: "column",
              textAlign: "center",
              fontSize: 14,
            }}
          >
            +964123456789 / +964987654321
          </div>
        </div>
        <div className="Doctor-leftCard">
          <Form
            style={{ width: "65%" }}
            onSubmit={(e) => {
              e.preventDefault();
              login();
            }}
          >
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>اسم المستخدم</Form.Label>
              <Form.Control
                onChange={(e) => setIdText(e.target.value)}
                style={{
                  display: "flex",
                  textAlign: "right",
                  alignItems: "center",
                }}
                type="text"
                placeholder="(ahmed-mohammed) مثال"
              />
              <Form.Text className="text-muted" style={{ fontSize: 12 }}>
                تنويه : نحن لا نقوم بمشاركة المعلومات مع اي شخص آخر
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>كلمة المرور</Form.Label>
              <Form.Control
                onChange={(e) => setPasswordText(e.target.value)}
                type={passwordType ? "text" : "password"}
                style={{
                  display: "flex",
                  textAlign: "right",
                  alignItems: "center",
                }}
                placeholder="************"
              />
              <div
                style={{
                  height: 20,
                  display: "flex",
                  marginTop: -30,
                  marginLeft: 10,
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
                onClick={() => setPasswordType(!passwordType)}
              >
                {passwordType ? (
                  <AiIcons.AiFillEye size={20} style={{ cursor: "pointer" }} />
                ) : (
                  <AiIcons.AiFillEyeInvisible
                    size={20}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </div>
            </Form.Group>
            <Form.Group
              className="mb-3"
              style={{
                display: "flex",
                fontSize: 16,
                justifyContent: "flex-start",
                alignItems: "center",
              }}
              controlId="formBasicCheckbox"
            >
              <Form.Check type="checkbox" label="تذكرني" />
            </Form.Group>
            <Button
              variant="primary"
              style={{
                width: "100%",
                backgroundColor: "#9A593C",
                borderColor: "#9A593C",
              }}
              type="submit"
            >
              

              {!loading ? (
                    "تسجيل الدخول"
                  ) : (
                    <div class="spinner-border " role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  )}
            </Button>
            {erroMsg ? (
              erroMsg.empty ? (
                <div style={{ color: "red", fontSize: 14, marginTop: 10 }}>
                  ! يرجى ملئ الحقول اولاً
                </div>
              ) : erroMsg.wrongInfo ? (
                <div style={{ color: "red", fontSize: 14, marginTop: 10 }}>
                  ! هنالك خطأ في المعلومات المدخلة
                </div>
              ) : null
            ) : null}
          </Form>
        </div>

        <NavLink className="back-btn" to="/" exact="true">
          <BsIcons.BsArrowLeft size={40} color="#00000099" />
        </NavLink>
      </div>
    </div>
  );
};

export default MOFLogin;
